<template>
  <div>
    <div class="bg-white border border-border rounded-md lg:mb-5 mb-4">
      <div class="flex w-full border-b border-border !m-0 p-4 gap-[8px] items-center">
        <span class="number-badge"><span v-if="(state.opt_type != 'general' && state.opt_type != 'SEIU721')">1</span><span
            v-if="(state.opt_type == 'general' || state.opt_type == 'SEIU721')">2</span></span>
        <h6 class="card-title !m-0">Address Information</h6>
      </div>
      <div class="p-4">
        <div class="form-group mb-4">
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            Your Address<span class="text-error">*</span>
          </label>
          <vue-google-autocomplete class="mt-1" id="address"
            classname="w-full text-black border border-blue-100 rounded py-2 px-4 mb-3" placeholder="Enter Your Address"
            ref="address" @blur="v$.form.address.$touch()"  :types="['address']" v-model="form.address"
            v-on:placechanged="
              handlePlaceChange
              ">
          </vue-google-autocomplete>
          <small v-if="v$.form.address.$error" class="text-error text-xs">
            Address is required.
          </small>
          <small class="mt-[8px] block text-mute text-xs font-normal">
            As you type, you will see a possible list of addresses. Select the correct address.
          </small>
        </div>
        <div class="form-group mb-4">
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            Address Line 1<span class="text-error">*</span>
          </label>
          <input type="text" placeholder="Enter Address Line 1" class="form" v-model="form.address1"
            @blur="v$.form.address1.$touch()" />
          <small v-if="v$.form.address1.$error" class="text-error text-xs">
            Address Line 1 is required.
          </small>
        </div>
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <div>
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            Address Line 2
          </label>
          <input type="text" placeholder="Enter Address Line 2" class="form" v-model="form.address2" />
        </div>
        <div>
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            County
          </label>
          <input type="text" placeholder="Enter County" class="form" v-model="form.county" />
        </div>
        </div>
        <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div>
            <label class="font-normal text-mute text-sm mb-2 inline-block">
              City<span class="text-error">*</span>
            </label>
            <input type="text" placeholder="Enter City" class="form" v-model="form.city"
              @blur="v$.form.city.$touch()" />
            <small v-if="v$.form.city.$error" class="text-error text-xs">
              City is required.
            </small>
          </div>
          <div>
            <label class="font-normal text-mute text-sm mb-2 inline-block">
              State<span class="text-error">*</span>
            </label>
            <input type="text" placeholder="Enter State" class="form" v-model="form.state"
              @blur="v$.form.state.$touch()" />
            <small v-if="v$.form.state.$error" class="text-error text-xs">
              State is required.
            </small>
          </div>
          <div>
            <label class="font-normal text-mute text-sm mb-2 inline-block">
              ZIP Code<span class="text-error">*</span>
            </label>
            <input type="text" placeholder="Enter ZIP Code" class="form" v-model="form.zip"
              @blur="v$.form.zip.$touch()" />
            <small v-if="v$.form.zip.$error" class="text-error text-xs">
              ZIP Code is required.
            </small>
          </div>
        </div>
        <div class="flex items-start justify-start gap-4 mt-4">
          <button class="primary-button" @click="submitForm">Get Plan</button>
          <button class="primary-outline-button" @click="resetForm">Reset</button>
        </div>
      </div>
    </div>
    <div v-if="state.enroll_msg" class="bg-red-500 border border-border rounded-md lg:mb-5 mb-4 hidden lg:block mt-5">
      <div class="p-4 flex items-start justify-start gap-4">
        <span
          class="w-[50px] h-[50px] bg-primaryLight border border-border flex rounded-md items-center justify-center shrink-0">
          <img src="@/assets/images/info.svg" alt="info">
        </span>
        <div>
          <p class="content !text-white">
            Thank you for your interest. At this time, U.S. Legal is not accepting enrollments in your state. If you
            have
            questions, please contact Customer Service at
           (800) 356-LAWS.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { reactive, watchEffect } from "vue";
import { computed } from "vue";
import Swal from "sweetalert2";
import VueGoogleAutocomplete from "vue-google-autocomplete"; // For address autocomplete from Google
import filter from "lodash/filter";

export default {
  name: "AddressInfoSection",
  props: {
    state: {
      type: Object,
    },
    searchObject: {
      type: Object,
    },
  },
  setup(props) {
    // Reactive form data
    const form = reactive({
      address: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      county: "",
    });

    // Validation rules
    const rules = computed(() => ({
      form: {
        address: { required },
        address1: { required },
        city: { required },
        state: { required },
        zip: { required },
      },
    }));

    const v$ = useVuelidate(rules, { form });
    // Populate the form with state.member data if available
    watchEffect(() => {
      if (props.state.member && form.address == '') {
        console.log('nehal')
        form.address1 = props.state.member.address || "";
        form.address = [
          props.state.member.address,
          props.state.member.city,
          props.state.member.state,
          props.state.member.zip
        ].filter(Boolean).join(" ");

        setTimeout(() => {
          document.getElementById("address").value = form.address;

        }, 200);
        form.city = props.state.member.city || "";
        form.state = props.state.member.state || "";
        form.zip = props.state.member.zip || "";
      }
      if (props.state.reset_form == true) {
        Object.entries(form).forEach(([key, val]) => {
          console.log(val)
          form[key] = ""; // Correct for Vue 3
        });
        setTimeout(() => {
          document.getElementById("address").value = "";
        }, 200);
        v$.value.$reset();
      }
    });

    return {
      form,
      v$,
    };
  },
  components: {
    VueGoogleAutocomplete,
  },
  methods: {
    submitForm: async function () {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.state.opt_type == "SEIU721" && (!this.state.company_number || this.state.company_number === "")) {
          Swal.fire({
            title: "Error!",
            text: "Please select company before proceeding!",
            icon: "error",
            confirmButtonText: "OK",
          });
          return false;
        }
        this.$emit("updateState", {
          key: "member",
          value: {
            address: this.form.address,
            address1: this.form.address1,
            address2: this.form.address2,
            city: this.form.city,
            state: this.form.state,
            zip: this.form.zip,
          },
        });
        this.$emit("updateState", { key: "cdl_plan", value: false });
        this.$emit("updateState", { key: "payment_method", value: "" });
        this.$emit("getEffDate");

        const state = filter(this.state.states, { abbreviation: this.form.state });
        if (state.length == 0) {
          this.$emit("updateState", { key: "disp_enroll_section", value: false });
          Swal.fire({
            title: "Error!",
            text: "State field is invalid.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return false;
        }

        if (this.state.opt_type === "direct_page" || this.state.enroll_option === "affilliated") {
          if (this.state.opt_type === "direct_page") {
            this.$emit("updateState", { key: "company_number", value: this.searchObject.opt });
          }
          if (this.state.enroll_option === "affilliated") {
            this.$emit("updateState", { key: "company_number", value: this.state.company.number });
          }
        }

        let payload = {
          state: this.state.member.state,
          opt_type: this.state.opt_type,
          referer_url: this.state.referer_url,
          api_name: "getPlanSettings",
          is_list: true,
          city: this.state.member.city,
          zip: this.state.member.zip,
        };

        if (this.state.enroll_option != "individual") {
          payload = {
            company: this.state.company_number,
            opt_type: this.state.opt_type,
            referer_url: this.state.referer_url,
            api_name: "getPlanSettings",
            is_list: false,
            city: this.state.member.city,
            zip: this.state.member.zip,
          };
        }

        if (this.searchObject.opt === "mdsid") {
          this.$emit("updateState", {
            key: "company_number",
            value: this.state.company.company,
          });

          payload = {
            company: this.state.company.company,
            referer_url: this.state.referer_url,
            api_name: "getPlanSettings",
            city: this.state.member.city,
            zip: this.state.member.zip,
          };
        }

        console.log(payload);
        await this.$emit("getPlan", payload);
      }
    },
    resetForm: function () {
        Object.entries(this.form).forEach(([key, val]) => {
          console.log(val)
          this.form[key] = "";
          this.$emit("updateState", { key: "member." + key, value: "" });
        });
     
      setTimeout(() => {
        document.getElementById("address").value = "";
        this.$emit("resetForm");

      }, 400);
      this.v$.$reset();
    },
    handlePlaceChange: function (place) {
      setTimeout(async () => {
        console.log(place,'address');
        let address2;
        if (this.$refs["address"].autocompleteText) {
          address2 = this.$refs["address"].autocompleteText?.split(",");
        }
        if(place.street_number!=undefined){
           this.form.address1 = place.street_number+' '+place.route;
        }else{
          this.form.address1 = place.route;
        }
        if (place.administrative_area_level_2) {
            this.form.county = place.administrative_area_level_2;
          }
        if (address2.length > 1) {
          if (
            place.locality?.toLowerCase().replace(/\s+/g, "") !=
            address2[1].toLowerCase().replace(/\s+/g, "")
          ) {
            // this.form.address2 = address2[1];
          } else if (place.administrative_area_level_2) {
            // this.form.county = place.administrative_area_level_2;
          } else {
            this.form.address2 = "";
          }
        }
        this.form.city = place.locality;
        this.form.state = place.administrative_area_level_1;
        this.form.zip = place.postal_code;
      }, 300);
    },
  },
};
</script>


<style scoped>
/* Add component-specific styles here if needed */
</style>
